// src/pages/Home.js
import { Box, SimpleGrid, Text, Link as ChakraLink, Button } from "@chakra-ui/react";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";

const Home = () => {
  // Function to trigger download
  const handleDownload = () => {
    // This opens your backend Excel download route
    window.open(`${process.env.REACT_APP_BACKEND_URL || "https://razor-pay-server-389286764509.asia-south1.run.app"}/book/users/download`, "_blank");
  };

  return (
    <Layout>
      <Box
        mt={{ base: 8, md: 10 }}
        px={{ base: 4, md: 8, lg: 16 }}
        textAlign="center"
        maxW="1200px"
        mx="auto"
      >
        <Text
          fontSize={{ base: "2xl", sm: "3xl", md: "4xl" }}
          fontWeight="bold"
          mb={{ base: 6, md: 10 }}
        >
          Book Distribution Management
        </Text>

        <SimpleGrid
          columns={{ base: 1, sm: 2, md: 3 }}
          spacing={{ base: 4, sm: 6, md: 8 }}
          px={{ base: 0, sm: 4, md: 0 }}
        >
          <NavCard to="/add-event" label="Add Event" />
          <NavCard to="/event-list" label="Get Event" />
          <NavCard to="/users" label="Get Users" />
          <NavCard to="/addBook" label="Add Book" />
          <NavCard to="/getAllBooks" label="Get All Books" />

          {/* ✅ New Download Button */}
          <Box
            p={{ base: 6, md: 8 }}
            bg="gray.100"
            borderRadius="lg"
            boxShadow="md"
            textAlign="center"
          >
            <Button
              
              onClick={handleDownload}
              
            >
              Download Users (Excel)
            </Button>
          </Box>
        </SimpleGrid>
      </Box>
    </Layout>
  );
};

const NavCard = ({ to, label }) => (
  <ChakraLink
    as={Link}
    to={to}
    p={{ base: 6, md: 8 }}
    bg="gray.100"
    borderRadius="lg"
    boxShadow="md"
    _hover={{
      bg: "blue.100",
      textDecoration: "none",
      transform: "scale(1.05)",
      boxShadow: "lg",
    }}
    transition="all 0.2s ease-in-out"
    textAlign="center"
    fontWeight="medium"
    fontSize={{ base: "lg", md: "xl" }}
  >
    {label}
  </ChakraLink>
);

export default Home;
